export default {
  // Navigation
  nav_categories: "Categories",
  nav_guides: "Guides",
  nav_reviews: "Reviews",
  nav_shipping: "Shipping",
  nav_about: "About",
  nav_contact: "Contact",
  nav_language: "Language",

  // Hero Section
  hero_h1: "AllChinaBuy Spreadsheet — Find Products, Compare Options & Shop Smarter",
  hero_subtitle: "Explore AllChinaBuy spreadsheet resources, product finds, QC guides, shipping information, reviews and comparisons — organized in one easy-to-use resource hub.",
  hero_cta_primary: "Explore AllChinaBuy Spreadsheet",
  hero_cta_secondary: "Buy It Now",
  hero_search_placeholder: "Search AllChinaBuy spreadsheet, products, shipping, QC or guides...",

  // Category Section
  categories_title: "Popular Categories",
  categories_subtitle: "Browse our curated product categories and find the best deals on AllChinaBuy",
  category_shoes: "Shoes",
  category_hoodies: "Hoodies / Sweaters",
  category_tshirts: "T-Shirts",
  category_jackets: "Jackets",
  category_pants: "Pants / Shorts",
  category_headwear: "Headwear",
  category_sets: "Sets",
  category_underwear: "Underwear",
  category_jersey: "Jersey",
  category_accessories: "Accessories",
  category_bags: "Bags",
  category_belts: "Belts",
  category_perfumes: "Perfumes",
  category_other: "Other Stuff",
  category_button: "Browse All",

  // Articles Section
  articles_title: "Latest Guides & Resources",
  articles_subtitle: "In-depth articles to help you shop smarter on AllChinaBuy",
  article_read_more: "Read Guide",
  article_read_time: "min read",
  article_allchinabuy_spreadsheet_guide: "AllChinaBuy Spreadsheet Complete Guide",
  article_allchinabuy_spreadsheet_guide_desc: "The ultimate guide to using AllChinaBuy spreadsheet for finding products, comparing prices, and making informed purchases in 2026.",
  article_allchinabuy_review: "AllChinaBuy Review 2026",
  article_allchinabuy_review_desc: "Comprehensive review covering features, fees, shipping options, customer support, and real user experiences.",
  article_shipping_cost: "AllChinaBuy Shipping Cost Guide",
  article_shipping_cost_desc: "Complete breakdown of shipping methods, costs by country, and tips to reduce your shipping expenses.",
  article_allchinabuy_coupon: "AllChinaBuy Coupon & Discount Codes",
  article_allchinabuy_coupon_desc: "Current coupons, discount codes, and money-saving tips for AllChinaBuy shoppers.",
  article_allchinabuy_vs: "AllChinaBuy vs Competitors",
  article_allchinabuy_vs_desc: "Detailed comparison of AllChinaBuy with Superbuy, CSSBuy, Sugargoo, and Pandabuy.",
  article_allchinabuy_legit: "Is AllChinaBuy Legit?",
  article_allchinabuy_legit_desc: "Safety guide covering payment security, QC processes, warehouse storage, and how to avoid scams.",
  article_allchinabuy_qc: "AllChinaBuy QC Guide",
  article_allchinabuy_qc_desc: "How to use AllChinaBuy's quality check service to inspect your items before international shipping.",
  article_allchinabuy_warehouse: "AllChinaBuy Warehouse Guide",
  article_allchinabuy_warehouse_desc: "Understanding warehouse storage, inspection, and consolidation services at AllChinaBuy.",

  // CTA Section
  cta_title: "Ready to Explore AllChinaBuy?",
  cta_subtitle: "Research first. Compare options. Make better-informed decisions.",
  cta_button: "AllChinaBuy Spreadsheet",
  cta_button_secondary: "Buy It Now",

  // FAQ Section
  faq_title: "Frequently Asked Questions",
  faq_1_q: "What is AllChinaBuy Spreadsheet?",
  faq_1_a: "AllChinaBuy Spreadsheet is a curated collection of product links, prices, and seller information organized in an easy-to-use format. It helps shoppers find the best deals on shoes, clothing, accessories, and more from Chinese shopping platforms.",
  faq_2_q: "Is AllChinaBuy safe to use?",
  faq_2_a: "AllChinaBuy implements standard security measures including encrypted payments, warehouse quality checks, and buyer protection policies. However, as with any international shopping service, we recommend researching sellers and using the QC (quality check) service before shipping items internationally.",
  faq_3_q: "How much does AllChinaBuy shipping cost?",
  faq_3_a: "Shipping costs vary by destination country, parcel weight, and shipping method. AllChinaBuy offers multiple shipping lines including EMS, DHL, FedEx, and budget options. Use our shipping calculator guide to estimate costs for your specific order.",
  faq_4_q: "Does AllChinaBuy offer coupons or discount codes?",
  faq_4_a: "Yes, AllChinaBuy regularly provides coupons and promotional discount codes for new and existing customers. Check our coupon guide for current active codes and money-saving strategies.",
  faq_5_q: "How does AllChinaBuy compare to other shopping agents?",
  faq_5_a: "AllChinaBuy offers competitive shipping rates, a user-friendly interface, and comprehensive spreadsheet resources. Compared to Superbuy, CSSBuy, and Sugargoo, AllChinaBuy stands out for its organized product spreadsheets and straightforward fee structure. Read our detailed comparison guides for more information.",
  faq_6_q: "What countries does AllChinaBuy ship to?",
  faq_6_a: "AllChinaBuy ships to most countries worldwide including the USA, UK, Canada, Germany, France, Denmark, Australia, and across Europe. Shipping times and costs vary by destination.",
  faq_7_q: "Can I get a refund if my order is wrong?",
  faq_7_a: "AllChinaBuy provides refund and return options depending on the seller's policy and the stage of your order. Items that haven't been shipped from the warehouse can typically be returned. Once shipped internationally, returns become more complex and may involve additional fees.",
  faq_8_q: "How do I use the AllChinaBuy spreadsheet?",
  faq_8_a: "Using the AllChinaBuy spreadsheet is simple: browse categories, click product links to view items, add desired products to your cart, and proceed with the purchasing process. Our complete guide provides step-by-step instructions with screenshots.",

  // Footer
  footer_title: "AllChinaBuy Spreadsheet",
  footer_desc: "Your trusted resource for AllChinaBuy product research, reviews, and shopping guides. We help you make informed decisions when shopping from China.",
  footer_links: "Quick Links",
  footer_resources: "Resources",
  footer_legal: "Legal",
  footer_privacy: "Privacy Policy",
  footer_terms: "Terms of Service",
  footer_disclaimer: "Disclaimer",
  footer_contact: "Contact Us",
  footer_copyright: "AllChinaBuy Spreadsheet. All rights reserved. This is an independent informational resource and is not affiliated with or operated by AllChinaBuy unless explicitly stated.",

  // Article Page
  article_back_home: "Back to Home",
  article_toc: "Table of Contents",
  article_last_updated: "Last Updated",
  article_author: "Author",
  article_reading_time: "Reading Time",
  article_related: "Related Articles",
  article_faq_title: "Frequently Asked Questions",
  article_share: "Share this guide",
  article_cta_text: "Ready to start shopping with AllChinaBuy?",
  article_cta_button: "Explore AllChinaBuy Spreadsheet",
  article_cta_button_buy: "Buy It Now",

  // About Page
  about_title: "About AllChinaBuy Spreadsheet",
  about_desc: "We are an independent resource hub dedicated to helping shoppers navigate the world of Chinese shopping agents. Our mission is to provide transparent, accurate, and helpful information about AllChinaBuy and related services.",
  about_mission: "Our Mission",
  about_mission_desc: "To empower international shoppers with the knowledge and tools needed to make confident purchasing decisions when using AllChinaBuy and similar shopping agent services.",
  about_vision: "Our Vision",
  about_vision_desc: "To become the most trusted independent resource for AllChinaBuy shoppers worldwide, covering every aspect of the shopping experience from product research to delivery.",
  about_values: "Our Values",
  about_values_transparency: "Transparency in all our reviews and comparisons",
  about_values_accuracy: "Accurate, up-to-date information",
  about_values_independence: "Independence from any shopping agent company",
  about_values_helpfulness: "Helpful content that solves real problems",

  // Contact Page
  contact_title: "Contact Us",
  contact_desc: "Have questions about AllChinaBuy? We're here to help. Reach out to our team for inquiries, suggestions, or collaboration opportunities.",
  contact_form_name: "Your Name",
  contact_form_email: "Email Address",
  contact_form_subject: "Subject",
  contact_form_message: "Message",
  contact_form_submit: "Send Message",
  contact_info: "Contact Information",
  contact_response: "We typically respond within 24-48 hours.",

  // Breadcrumb
  breadcrumb_home: "Home",
  breadcrumb_article: "Article",
  breadcrumb_about: "About",
  breadcrumb_contact: "Contact",
};